<template>
    <div class="c-project-detail-middle">
        <MainLayout :showLeft="false">
            <div slot="main" style="height: 100%; margin-right: 10px">
                <div class="c-project-detail-middle__header">
                    <i class="el-icon-arrow-left arrow-back" @click="goBack"></i>
                    {{ title }}
                    <div class="button-group">
                        <div
                            class="button-group__btn"
                            :class="{ 'button-group__btn-active': activeTab === 'process' }"
                            @click="changeTab('process')"
                        >
                            里程碑节点
                        </div>
                        <div
                            class="button-group__btn"
                            :class="{ 'button-group__btn-active': activeTab === 'picture' }"
                            @click="changeTab('picture')"
                        >
                            图册
                        </div>
                    </div>
                </div>
                <BgWrap class="c-project-detail-middle__content">
                    <!-- 里程碑 -->
                    <template v-if="activeTab === 'process'">
                        <div class="c-project-detail-middle__content--timeline-box">
                            <TimeLine :data="timeLineData" :current="1">
                                <template v-slot:content="scope">
                                    <div class="time-line-content">
                                        <div>{{ scope.data.name }}</div>
                                        <div>{{ scope.data.planDate }}</div>
                                    </div>
                                </template>
                            </TimeLine>
                        </div>
                        <div class="info-box">
                            <div class="info-title">
                                项目概要
                                <span
                                    style="
                                        padding-left: 30px;
                                        color: rgba(255, 255, 255, 0.2);
                                        font-size: 14px;
                                    "
                                    >PROJECT OVERVIEW</span
                                >
                            </div>
                            <el-row class="c-row c-row-odd">
                                <el-col :span="colSpan">
                                    <div class="c-col col-center">项目类型</div>
                                </el-col>
                                <el-col :span="colSpan">
                                    <div class="c-col col-center">
                                        {{ mixin_ProjectTypeDic[formData.typeFirst] }}
                                    </div>
                                </el-col>
                                <el-col :span="colSpan">
                                    <div class="c-col col-center">建设单位</div>
                                </el-col>
                                <el-col :span="colSpan">
                                    <div class="c-col col-center">{{ formData.build }}</div>
                                </el-col>
                            </el-row>
                            <el-row class="c-row">
                                <el-col :span="colSpan">
                                    <div class="c-col col-center">总投资(万元)</div>
                                </el-col>
                                <el-col :span="colSpan">
                                    <div class="c-col col-center">{{ formData.invest }}</div>
                                </el-col>
                                <el-col :span="colSpan">
                                    <div class="c-col col-center">监理单位</div>
                                </el-col>
                                <el-col :span="colSpan">
                                    <div class="c-col col-center">{{ formData.sup }}</div>
                                </el-col>
                            </el-row>
                            <el-row class="c-row c-row-odd">
                                <el-col :span="colSpan">
                                    <div class="c-col col-center">工程面积(㎡)</div>
                                </el-col>
                                <el-col :span="colSpan">
                                    <div class="c-col col-center">{{ formData.area }}</div>
                                </el-col>
                                <el-col :span="colSpan">
                                    <div class="c-col col-center">勘测单位</div>
                                </el-col>
                                <el-col :span="colSpan">
                                    <div class="c-col col-center"></div>
                                </el-col>
                            </el-row>
                            <el-row class="c-row">
                                <el-col :span="colSpan">
                                    <div class="c-col col-center">工程位置</div>
                                </el-col>
                                <el-col :span="colSpan">
                                    <div class="c-col col-center">{{ formData.address }}</div>
                                </el-col>
                                <el-col :span="colSpan">
                                    <div class="c-col col-center">施工单位</div>
                                </el-col>
                                <el-col :span="colSpan">
                                    <div class="c-col col-center">{{ formData.conEnterprise }}</div>
                                </el-col>
                            </el-row>
                        </div>
                    </template>
                    <!-- 图册 -->
                    <template v-else-if="activeTab === 'picture'">
                        <PictureBox :images="images"></PictureBox>
                    </template>
                </BgWrap>
            </div>

            <!-- 右侧 -->
            <BgWrap
                slot="right"
                style="height: 100%; position: relative"
                class="c-project-detail-middle__right"
            >
                <AsideTitle>阶段信息</AsideTitle>
                <el-scrollbar class="scroll-main">
                    <div style="padding: 14px">
                        <template v-if="atlasList.length > 0">
                            <PictureCard
                                v-for="(item, index) in atlasList"
                                :key="index"
                                :url="item.thumbSrc"
                                cardType="picture"
                                width="100%"
                                height="216px"
                                style="margin-right: 0px; margin-bottom: 16px"
                                @click="handlePictureCardClick(item)"
                            ></PictureCard>
                        </template>
                        <template v-else>
                            <el-empty description="暂无数据~"><div slot="image"></div></el-empty>
                        </template>
                    </div>
                </el-scrollbar>
            </BgWrap>
        </MainLayout>
    </div>
</template>

<script>
import BgWrap from '../../../layout/components/BgWrap.vue';
import TimeLine from '../../../components/TimeLine.vue';
import AsideTitle from '../../../components/AsideTitle';
import PictureCard from '../../../components/PictureCard/PictureCard.vue';
import { fetchProjectStagePicList, fetchDetailById } from '../../Api';
import DicMixin from '../../../mixins/DicMixin';
import MainLayout from '../../../layout/MainLayout.vue';
import PictureBox from './PictureBox.vue';

export default {
    mixins: [DicMixin],
    components: {
        BgWrap,
        TimeLine,
        AsideTitle,
        MainLayout,
        PictureCard,
        PictureBox,
    },
    props: {
        title: {
            type: String,
            default: '',
        },
        projectId: {
            // 工程id
            type: String,
            default: '',
        },
    },
    data() {
        return {
            colSpan: 6,
            timeLineData: [],
            formData: {},
            // atlasList: [
            //     {
            //         url: 'https://t7.baidu.com/it/u=4162611394,4275913936&fm=193&f=GIF',
            //     },
            //     {
            //         url: 'https://t7.baidu.com/it/u=1653900808,1273534310&fm=193&f=GIF',
            //     },
            //     {
            //         url: 'https://t7.baidu.com/it/u=2807573989,921590260&fm=193&f=GIF',
            //     },
            //     {
            //         url: 'https://t7.baidu.com/it/u=1653900808,1273534310&fm=193&f=GIF',
            //     },
            // ],
            images: [
                // 'https://t7.baidu.com/it/u=4162611394,4275913936&fm=193&f=GIF',
                // 'https://t7.baidu.com/it/u=1653900808,1273534310&fm=193&f=GIF',
                // 'https://t7.baidu.com/it/u=2807573989,921590260&fm=193&f=GIF',
                // 'https://t7.baidu.com/it/u=4162611394,4275913936&fm=193&f=GIF',
                // 'https://img0.baidu.com/it/u=1844205561,469005669&fm=253&fmt=auto&app=138&f=JPEG?w=658&h=483',
                // 'https://img2.baidu.com/it/u=2616001959,1405306925&fm=253&fmt=auto&app=138&f=JPEG?w=658&h=411',
                // 'https://t7.baidu.com/it/u=4162611394,4275913936&fm=193&f=GIF',
            ],
            activeTab: 'process', // process 里程碑,picture：图册
        };
    },
    computed: {
        atlasList() {
            let res = [];
            let timeLineData = this.timeLineData;
            timeLineData.forEach((item) => {
                let pictureList = item.pictureList || [];
                let thumbSrc = '';
                if (pictureList.length > 0) {
                    thumbSrc = pictureList[0].fullPath;
                }

                let obj = item;
                obj.thumbSrc = thumbSrc;
                res.push(obj);
            });
            return res;
        },
    },
    methods: {
        goBack() {
            this.$router.back();
        },
        changeTab(tab) {
            this.activeTab = tab;
            if (tab === 'picture') {
                if (this.images.length < 1) {
                    if (this.atlasList.length > 0) {
                        this.handlePictureCardClick(this.atlasList[0]);
                    }
                }
            }
        },
        /**
         * 右侧图册点击
         */
        handlePictureCardClick(data) {
            let res = [];
            let pictureList = data.pictureList || [];
            pictureList.forEach((item) => {
                let src = item.fullPath || '';
                res.push(src);
            });
            this.images = res;
            this.activeTab = 'picture';
        },
        /**
         * 获取时间线
         */
        getProjectStageList() {
            let projectId = this.projectId;
            let list = [];
            if (projectId) {
                fetchProjectStagePicList({ projectId })
                    .run()
                    .then((res) => {
                        list = res || [];
                        this.timeLineData = list;
                    });
            } else {
                this.timeLineData = list;
            }
        },
        /**
         * 获取工程信息
         */
        getDetail() {
            const id = this.projectId;
            if (id) {
                fetchDetailById(id)
                    .run()
                    .then((res) => {
                        this.formData = res || {};
                        console.log(res);
                    });
            } else {
                this.formData = {};
            }
        },
        // 获取数据字典
        getDic() {
            this.mixinGetProjectTypeDic();
        },
    },
    created() {
        this.getDic();
    },
    mounted() {
        this.getProjectStageList();
        this.getDetail();
    },
    watch: {
        projectId() {
            this.getProjectStageList();
            this.getDetail();
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@Theme/config.scss';
@import '~@Theme/mixins/index.scss';
$header-height: 40px;
$bg-1: #071150;
$bg-2: #154fdb;
@include b(project-detail-middle, c) {
    height: 100%;
    width: 100%;
    position: relative;
    @include e(header) {
        height: $header-height;
        display: flex;
        box-sizing: border-box;
        align-items: center;
        .arrow-back {
            cursor: pointer;
            font-size: 20px;
        }
        .button-group {
            display: inline-flex;
            box-sizing: border-box;
            margin-left: auto;
            &__btn {
                border: 1px solid #1a47a4;
                height: 34px;
                display: flex;
                align-items: center;
                justify-content: center;
                box-sizing: border-box;
                width: 100px;
                cursor: pointer;
                &:hover,
                &-active {
                    background: $bg-2;
                }
            }
        }
    }
    @include e(content) {
        padding: 16px;
        height: calc(100% - #{$header-height} - 16px - 16px);
        background: $bg-1;
        @include m(timeline-box) {
            padding: 12px;
        }
        .time-line-content {
            line-height: 1.5;
            padding-left: 12px;
        }
        ::v-deep .c-time-line__item {
            width: 25%;
            .c-time-line__item-tail > i {
                &::after {
                    background-color: #1c2277;
                }
            }
        }

        .info-box {
            .info-title {
                width: 314px;
                padding-left: 40px;
                height: 40px;
                display: inline-flex;
                box-sizing: border-box;
                align-items: center;
                // background: linear-gradient(90deg, rgba(85, 102, 255, 0.3) 0%, rgba(85, 102, 255, 0) 100%);
                position: relative;
                margin-bottom: 24px;
                &::before {
                    content: '';
                    position: absolute;
                    top: 0;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    background-image: url('../../../imgs/bg_title.png');
                    z-index: -1;
                }
            }
            .c-row {
                line-height: 1.5;
                &-odd {
                    background-color: #0a2a84;
                }
            }
            .c-col {
                height: 40px;
                display: flex;
                box-sizing: border-box;
            }
            .col-center {
                align-items: center;
                justify-content: center;
            }
        }
    }
    @include e(right) {
        background: $bg-1;
    }
    .scroll-main {
        height: calc(100% - 48px - 12px);
        overflow-x: hidden;
        ::v-deep .el-scrollbar__wrap {
            overflow-x: hidden;
        }
    }
}
</style>
